// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"p-","embed":"p_"};